/* eslint-disable max-lines */
import { Props as AddActionsProps } from "components/HomeVideoReviews/AddActions"
import { Props as MainProps } from "screens/HomeVideoReviews/Add/Main"
import { Props as ActionProps } from "screens/HomeVideoReviews/Add/Main/Actions"
import { fn } from "storybook/test"

import imageSelector from "./imageSelector"
import screenshotSelector from "./screenshotSelector"
import techSpecsSelector from "./techSpecsSelector"

const display = [
  {
    id: "a2f17242-0d90-5a9f-8bba-50b89cbff231",
    isFlagged: false,
    isNew: true,
    title: "Gamer 4K (2009)",
    url: "https://www.blu-ray.com/movies/Gamer-4K-Blu-ray/317489"
  },
  {
    id: "3306ce33-8d5c-5a12-95d9-ca3af65ae70f",
    isFlagged: false,
    isNew: true,
    title: "Malignant 4K (2021)",
    url: "https://www.blu-ray.com/movies/Malignant-4K-Blu-ray/314252"
  },
  {
    id: "f869bc6a-a7df-5a80-bd11-ab22eec42f57",
    isFlagged: false,
    isNew: true,
    title: "Happy Death Day 4K (2017)",
    url: "https://www.blu-ray.com/movies/Happy-Death-Day-4K-Blu-ray/310276"
  },
  {
    id: "6ac2030b-ee6c-53bd-a2fe-55e1354ac7aa",
    isFlagged: false,
    isNew: true,
    title: "Happy Death Day 2U 4K (2019)",
    url: "https://www.blu-ray.com/movies/Happy-Death-Day-2U-4K-Blu-ray/310275"
  },
  {
    id: "5b380a0f-aed5-541d-ab5a-ff06a29b637a",
    isFlagged: false,
    isNew: true,
    title: "Miami Connection 4K (1987)",
    url: "https://www.blu-ray.com/movies/Miami-Connection-4K-Blu-ray/313972"
  },
  {
    id: "1b2abc27-fec6-512f-a1c1-e45630757e43",
    isFlagged: false,
    isNew: true,
    title: "Ray Donovan: The Movie 4K (2022)",
    url: "https://www.blu-ray.com/movies/Ray-Donovan-The-Movie-4K-Blu-ray/315249"
  },
  {
    id: "b9ab93f4-9360-56d6-8ad7-d0162734be40",
    isFlagged: false,
    isNew: true,
    title: "The King's Man 4K (2021)",
    url: "https://www.blu-ray.com/movies/The-Kings-Man-4K-Blu-ray/273301"
  }
]

export const reviewsProps = {
  display,
  flagLoading: false,
  isShowFlagButton: true,
  onSelect: fn(),
  onToggleFlagged: () => fn(),
  selected: "",
  subheader: "Total New: 100"
}

export const reviewsPropsByService: MainProps["reviewsPropsByService"] = {
  avForums: {
    ...reviewsProps,
    avatar: "AVF",
    serviceName: "avForums",
    title: "AV Forums Reviews"
  },
  avNirvana: {
    ...reviewsProps,
    avatar: "AVN",
    serviceName: "avNirvana",
    title: "AV Nirvana Reviews"
  },
  avsForum: {
    ...reviewsProps,
    avatar: "AVSF",
    serviceName: "avsForum",
    title: "AVS Forum Reviews"
  },
  bluRay: {
    ...reviewsProps,
    avatar: "BR",
    serviceName: "bluRay",
    title: "Blu-ray.com Reviews"
  },
  bluRayAuthority: {
    ...reviewsProps,
    avatar: "BRA",
    serviceName: "bluRayAuthority",
    title: "Blu-ray Authority Reviews"
  },
  digitalBits: {
    ...reviewsProps,
    avatar: "DB",
    serviceName: "digitalBits",
    title: "Digital Bits Reviews"
  },
  doBlu: {
    ...reviewsProps,
    avatar: "DB",
    serviceName: "doBlu",
    title: "Do Blu Reviews"
  },
  hidefDigest: {
    ...reviewsProps,
    avatar: "HDD",
    serviceName: "hidefDigest",
    title: "Hi-Def Digest Reviews"
  },
  highDefDiscNews: {
    ...reviewsProps,
    avatar: "HDDN",
    serviceName: "highDefDiscNews",
    title: "HighDefDiscNews.com Reviews"
  },
  homeTheaterForum: {
    ...reviewsProps,
    avatar: "HTF",
    serviceName: "homeTheaterForum",
    title: "Home Theater Forum Reviews"
  },
  theaterByte: {
    ...reviewsProps,
    avatar: "TB",
    serviceName: "theaterByte",
    title: "Theater Byte Reviews"
  },
  whySoBlu: {
    ...reviewsProps,
    avatar: "WSB",
    serviceName: "whySoBlu",
    title: "Why So Blu? Reviews"
  }
}

export const addHomeVideoReviewActionsProps: AddActionsProps = {
  IMDb: {
    IMDbId: "",
    isImdbIdValid: false,
    onImdbIdChange: fn()
  },
  imageSelector,
  isAddHomeVideoReviewEnabled: false,
  isAdmin: false,
  isEditor: false,
  label: "Add Home Video Review",
  loading: false,
  name: "",
  onAddHomeVideoReview: fn(),
  onClearAll: fn(),
  onNameChange: fn(),
  screenshotSelector,
  searchHomeVideo: {
    homeVideoTitles: [],
    isLoading: false,
    isSearchHomeVideo: false
  },
  techSpecsSelector
}

const actionsProps: Omit<ActionProps, "isAdmin" | "isEditor" | "serviceName"> =
  {
    clearListButtonProps: {
      isDisabled: false,
      label: "Clear",
      loading: false,
      onClick: fn()
    },
    listButtonProps: {
      isDisabled: false,
      label: "List",
      loading: false,
      onClick: fn()
    },
    loadMoreProps: {
      isDisabled: false,
      loading: false,
      onClick: fn()
    },
    onlyNewProps: {
      checked: false,
      disabled: false,
      inputId: "onlyNew",
      label: "Only New",
      name: "onlyNew",
      onChange: fn()
    },
    onlyPresentProps: {
      checked: false,
      disabled: false,
      inputId: "onlyPresent",
      label: "Only Present",
      name: "onlyPresent",
      onChange: fn()
    },
    showFlaggedProps: {
      checked: false,
      disabled: false,
      inputId: "showFlagged",
      label: "Show Flagged",
      name: "showFlagged",
      onChange: fn()
    }
  }

const mainProps: MainProps = {
  actionsPropsByService: {
    avForums: { ...actionsProps, serviceName: "avForums" },
    avNirvana: { ...actionsProps, serviceName: "avNirvana" },
    avsForum: { ...actionsProps, serviceName: "avsForum" },
    bluRay: { ...actionsProps, serviceName: "bluRay" },
    bluRayAuthority: { ...actionsProps, serviceName: "bluRayAuthority" },
    digitalBits: { ...actionsProps, serviceName: "digitalBits" },
    doBlu: { ...actionsProps, serviceName: "doBlu" },
    hidefDigest: { ...actionsProps, serviceName: "hidefDigest" },
    highDefDiscNews: { ...actionsProps, serviceName: "highDefDiscNews" },
    homeTheaterForum: { ...actionsProps, serviceName: "homeTheaterForum" },
    theaterByte: { ...actionsProps, serviceName: "theaterByte" },
    whySoBlu: { ...actionsProps, serviceName: "whySoBlu" }
  },
  clearAllListsButtonProps: {
    isDisabled: false,
    label: "Clear All Lists",
    loading: false,
    onClick: fn(),
    secondary: true
  },
  isAdmin: false,
  isEditor: false,
  listAllButtonProps: {
    isDisabled: false,
    label: "List All",
    loading: false,
    onClick: fn()
  },
  reviewsPropsByService,
  services: [
    {
      id: "section-1",
      rows: [
        { name: "Blu-ray.com", serviceName: "bluRay" },
        { name: "AV Forums", serviceName: "avForums" },
        { name: "AVS Forum", serviceName: "avsForum" },
        { name: "Hi-Def Digest", serviceName: "hidefDigest" },
        { name: "Digital Bits", serviceName: "digitalBits" },
        { name: "Do Blu", serviceName: "doBlu" }
      ]
    },
    {
      id: "section-2",
      rows: [
        { name: "Why So Blu?", serviceName: "whySoBlu" },
        { name: "AV Nirvana", serviceName: "avNirvana" },
        { name: "HT Forum", serviceName: "homeTheaterForum" },
        { name: "Blu-ray Authority", serviceName: "bluRayAuthority" },
        { name: "HighDefDiscNews.com", serviceName: "highDefDiscNews" },
        { name: "Theater Byte", serviceName: "theaterByte" }
      ]
    }
  ]
}

const homeVideoReviewsScreen = {
  areReviewsLoading: false,
  avForums: {
    id: "172eb1c3-3a20-5d6b-9358-e3c49f86c8c1",
    isCreated: false,
    isPreviewLoading: false,
    isPreviewValid: true,
    review: {},
    url: "https://www.avforums.com/reviews/the-lost-city-4k-blu-ray-review-dolby-vision-atmos.19919"
  },
  avNirvana: {
    id: "062eb1c3-3a20-5d6b-9358-e3c49f86c8c1",
    isCreated: false,
    isPreviewLoading: false,
    isPreviewValid: true,
    review: {},
    url: "https://www.avnirvana.com/threads/godzilla-x-kong-the-new-empire-4k-blu-ray-review.13776/"
  },
  avsForum: {
    id: "811a937d-ab0f-5c63-a698-af51fc3cbc45",
    isCreated: false,
    isPreviewLoading: false,
    isPreviewValid: true,
    review: {},
    url: "https://www.avsforum.com/threads/the-lost-city-ultra-hd-blu-ray-review.3249681"
  },
  bluRay: {
    id: "06b6c38e-a112-5da4-a877-07b957f1dff0",
    isCreated: false,
    isPreviewLoading: false,
    isPreviewValid: true,
    review: {},
    url: "https://www.blu-ray.com/movies/Out-of-Sight-4K-Blu-ray/292097"
  },
  bluRayAuthority: {
    id: "06b6c38e-a112-5da4-a877-07b957f1dff0",
    isCreated: false,
    isPreviewLoading: false,
    isPreviewValid: true,
    review: {},
    url: "https://blurayauthority.com/4k/focus-4k/"
  },
  digitalBits: {
    id: "5397a1ad-1da9-56f8-8c8c-a30668bf1d5d",
    isCreated: false,
    isPreviewLoading: false,
    isPreviewValid: true,
    review: {},
    url: "https://thedigitalbits.com/item/out-of-sight-uhd"
  },
  doBlu: {
    id: "a29701ad-1d49-4628-12ad-a89ab85fga0e",
    isCreated: false,
    isPreviewLoading: false,
    isPreviewValid: true,
    review: {},
    url: "https://doblu.com/2020/09/08/out-of-sight-4k-review/"
  },
  hidefDigest: {
    id: "5397a1ad-1da9-56f8-8c8c-a30668bf1d5d",
    isCreated: false,
    isPreviewLoading: false,
    isPreviewValid: true,
    review: {},
    url: "https://ultrahd.highdefdigest.com/104679/outofsight4kultrahdbluray.html"
  },
  highDefDiscNews: {
    id: "062eb1c3-3a20-5d6b-9358-e3c49f86c8c1",
    isCreated: false,
    isPreviewLoading: false,
    isPreviewValid: true,
    review: {},
    url: "https://highdefdiscnews.com/2025/03/06/alice-sweet-alice-limited-edition-4k-uhd-blu-ray-review/"
  },
  homeTheaterForum: {
    id: "2397a1ad-1da9-56f8-8c8c-a30668bf1d5d",
    isCreated: false,
    isPreviewLoading: false,
    isPreviewValid: true,
    review: {},
    url: "https://www.hometheaterforum.com/godzilla-x-kong-the-new-empire-uhd-review/"
  },
  addHomeVideoReviewActionsProps,
  isAdmin: false,
  isEditor: false,
  mainProps,
  onClear: () => fn(),
  onSetReview: () => fn(),
  reviewsControlCheckboxesProps: {
    isAddHomeVideoCheckboxProps: {
      checked: false,
      isDisabled: false,
      onChange: fn()
    },
    isAdmin: false,
    isCompactCheckboxProps: {
      checked: false,
      isDisabled: false,
      onChange: fn()
    },
    isEditor: false,
    isMatchTitleCheckboxProps: {
      checked: true,
      isDisabled: false,
      onChange: fn()
    },
    isUHDCheckboxProps: {
      checked: true,
      isDisabled: false,
      onChange: fn()
    }
  },
  theaterByte: {
    id: "2397a1ad-1da9-56f8-8c8c-a30668bf1d5d",
    isCreated: false,
    isPreviewLoading: false,
    isPreviewValid: true,
    review: {},
    url: "https://www.theaterbyte.com/godzilla-x-kong-the-new-empire-uhd-review/"
  },
  whySoBlu: {
    id: "5397a1ad-1da9-56f8-8c8c-a30668bf1d5d",
    isCreated: false,
    isPreviewLoading: false,
    isPreviewValid: true,
    review: {},
    url: "https://ultrahd.highdefdigest.com/104679/outofsight4kultrahdbluray.html"
  }
}

export default homeVideoReviewsScreen
